export default {
  data() {
    return {
      fixedHeader: false,
      scrollTopMax: 300,
    }
  },
  mounted () {
    document.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.fixedHeader = document.documentElement.scrollTop > this.scrollTopMax - 93;
    },
  },
}